var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('img',{staticClass:"imgs",attrs:{"src":"https://cdn.51ljb.cn/ljb-404.png"}}),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":_vm.goHome}},[_vm._v("点击唤醒")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-45ba7142","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/ErrPage.vue
// module id = null
// module chunks = 